import { ReactNode, useMemo } from "react";
import { useAppTheme } from "../../../theme";

import {
  CONTACT_CENTER_THEMES,
  ContactCenterTheme,
  ContactCenterThemeId,
  DEFAULT_CONTACT_CENTER_THEME_ID,
  getContactCenterTheme,
} from "./contactCenterThemes";

export const CONTACT_CENTER_THEME_STORAGE_KEY = "flownect.contactCenter.theme";

interface ContactCenterThemeContextValue {
  theme: ContactCenterTheme;
  themeId: ContactCenterThemeId;
  themes: ContactCenterTheme[];
  setThemeId: (id: ContactCenterThemeId) => void;
}

export const ContactCenterThemeProvider = ({ children }: { children: ReactNode }) => <>{children}</>;

export const useContactCenterTheme = (): ContactCenterThemeContextValue => {
  const { themeId, setThemeId } = useAppTheme();

  return useMemo(
    () => ({
      theme: getContactCenterTheme(themeId),
      themeId: getContactCenterTheme(themeId).id,
      themes: CONTACT_CENTER_THEMES,
      setThemeId: (id: ContactCenterThemeId) => setThemeId(id),
    }),
    [themeId, setThemeId],
  );
};

export { DEFAULT_CONTACT_CENTER_THEME_ID };
